<template>
  <div>
    <v-select v-if="brands.length > 1"
              :items="brands"
              item-text="name"
              item-value="id"
              label="チケットブランドを選択してください。"
              v-model="brandId"
              @change="searchTicketBrand"
              class="UXselect"
              color="#6D8DFF"
              hide-details
              outline
              solo
              no-data-text="データがありません。"
    >
    </v-select>
    <v-select v-else :items="brands"
              item-text="name"
              item-value="id"
              no-data-text="ブランドがありません。"
              :readonly="brands.length === 1"
              v-model="brandId"
              class="UXselect notPoint"
              color="#6D8DFF"
              hide-details
              outline
              solo
    >
      </v-select>
  </div>
</template>

<script>
import {mapGetters, mapMutations} from 'vuex'
import eventBus from '@/event_bus'
import eventType from '@/components/menus/ticket/enums/eventType'

export default {
  data: () => {
    return {
      brands: [],
      brandId: '',
      brandName: ''
    }
  },
  mounted () {
    this.initialize()
  },
  computed: {
    ...mapGetters([
      'ticketAgentId',
      'currentTicketBrandId',
      'currentTicketBrandName'
    ])
  },
  methods: {
    ...mapMutations([
      'changeTicketBrandId',
      'changeTicketBrandName'
    ]),
    initialize () {
      if (!this.ticketAgentId) {
        this.$alertMsg('チケット権限がありません。')
        this.$router.push('/')
        return
      }

      this.axios.get(`/gateway/ticket/agent/${this.ticketAgentId}/brands`).then(result => {
        if (result.data.code === 0) {
          const data = result.data.data
          this.brands = []
          if (data.length === 0) {
            this.$alertMsg('接続したチケットブランド情報が存在しません。')
            this.$router.push('/dashboard')
            return
          }
          data.forEach(brand => {
            this.brands.push({id: brand.id, name: brand.name})
          })
          if (this.currentTicketBrandId) {
            this.brandId = this.currentTicketBrandId
            this.brandName = this.currentTicketBrandName
          } else {
            if (data.length > 0) {
              this.brandId = data[0].id
              this.brandName = data[0].name
              this.changeTicketBrandId(this.brandId)
              this.changeTicketBrandName(this.brandName)
            } else {
              this.changeTicketBrandId(null)
              this.changeTicketBrandName(null)
            }
          }
        } else {
          this.$alertMsg(result.data.message)
        }
      })
        .then(() => this.searchTicketBrand())
    },
    searchTicketBrand () {
      if (this.brands.length > 0) {
        eventBus.$emit('brand-loading-complete')
        this.changeTicketBrandId(this.brandId)
        this.changeTicketBrandName(this.brandName)
        if (this.currentTicketBrandId) {
          eventBus.$emit(eventType.FETCH_TICKET_BRAND)
          eventBus.$emit(eventType.REFRESH_TICKET_COUNT)
        }
      }
    }
  },
  destroyed () {
    eventBus.$off('brand-loading-complete')
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/menus/ticket/ticket_brand_select.vue